import { CATALOG_STATUS, ORDER_TYPE_NAMES } from './constants';

export const isCatalogIndexed = ({ status }) => status === CATALOG_STATUS.INDEX;

const { ATONCE, FORECAST } = ORDER_TYPE_NAMES;

export const isDirectShip = values =>
  values.orderTypes.includes(FORECAST) ||
  (values.orderTypes.includes(ATONCE) && values.orderTypes.includes(FORECAST)) ||
  values.orderTypes.toString() === 'ATONCE';

export const MandatoryFields = props => {
  // eslint-disable-next-line react/prop-types
  const { color } = props;
  return <span style={{ color: color }}>*</span>;
};

export const isValidProductCode = productCode => productCode.match(/^[a-zA-Z0-9]{6}-?[a-zA-Z0-9]{3}$/);

export const parseProductCodes = productCodes => {
  const validProductCodes = [];
  const invalidProductCodes = [];

  productCodes.forEach(productCode => {
    if (isValidProductCode(productCode)) {
      validProductCodes.push(productCode);
    } else {
      invalidProductCodes.push(productCode);
    }
  });

  return { validProductCodes, invalidProductCodes };
};
